import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Loader2, Flame } from "lucide-react";
import { toast } from "sonner";

export default function OAuthCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/token");
        if (data.token) localStorage.setItem("kv_token", data.token);
        await refresh();
        toast.success("Signed in");
        nav("/", { replace: true });
      } catch {
        toast.error("Sign in failed");
        nav("/login", { replace: true });
      }
    })();
  }, [nav, refresh]);

  return (
    <div className="min-h-[calc(100vh-4rem)] flex flex-col items-center justify-center gap-4">
      <Flame className="text-[#e50000]" size={32} strokeWidth={2.5} />
      <Loader2 className="animate-spin text-[#e50000]" size={28} />
      <p className="font-mono text-xs text-[#555] uppercase tracking-widest">Signing you in…</p>
    </div>
  );
}
